import React from 'react';
import { string, shape } from 'prop-types';

export default function BaseTile({ item }) {
    return (
        <a href={item.url} className="c-base-tile">
            {item.thumbnail &&
                <div className="tile-image-wrapper">
                    <div className="tile-image">
                        <img src={item.thumbnail} alt="" />
                    </div>
                </div>
            }
            <div className="tile-content">
                <h3>{item.title}</h3>
                {item.subtext &&
                    <p className="subtext">{item.subtext}</p>
                }
                {item.paragraph &&
                    <p>{item.paragraph}</p>
                }
            </div>
        </a>
    );
}

BaseTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        title: string.isRequired,
        subtext: string,
        excerpt: string,
        thumbnail: string
    }).isRequired
    /* eslint-enable react/no-typos */
};
